export let _createAlert: (title: string, message: string) => void;

export const initialize = async (
  createAlert: (title: string, message: string) => void
) => {
  // Assign the passed function to _createAlert
  _createAlert = createAlert;
};